<template>
  <div class="chat-container w-100 position-relative bg-white">
    <div id="hotel-room"></div>
    <!-- Hotel -->
    <template v-if="is_tab == 'Hotel'">   
      <flickity ref="flickity" class="room-detail" :options="flickityOptions">
        <div class="carousel-cell w-100" :id="slider_merchant.id" v-for="slider_merchant in  getMerchant().merchant_images">
          <div class="w-100" style="height: 250px !important;">
            <img :src="slider_merchant.image_url" class="img-fit" height="250">
          </div>
        </div>
      </flickity>
      <div class="container px-4 mt-1">
        <p class="mb-0 body-1-1 text-24 font-bold">{{getMerchant().name}}</p>
        <img src="../../assets/img/icon/hotel-star.png" width="15" class="d-inline-block mr-1 mb-1" v-for="data in getMerchant().star">
        <!-- <img src="../../assets/img/hotel/star.png" class="d-block mr-1 mb-1" width="50"> -->
        <div class="d-block">
          <img src="../../assets/img/icon/location.png" class="d-inline-block mr-1" width="10">
          <p class="mb-3 body-2 font-regular d-inline-block" v-if="getMerchant().location_name != '' && getMerchant().location_name != null">{{getMerchant().location_name}}</p>
          <p class="mb-3 body-2 font-regular d-inline-block" v-else>{{merchant_area}}</p>
        </div>
        <!-- <div class="d-block">
          <img src="../../assets/img/icon/tour.png" class="d-inline-block" width="80">
          <p class="mb-0 body-2-2 font-regular text-12 d-inline-block">5.233 {{$t('general.reviews')}}</p>
          <p class="mb-0 mt-1 d-block body-2-2 font-semibold text-green">{{$t('restaurant.see-visitor-review')}}</p>
        </div> -->
      </div>
      <!-- <div class="">
        <router-link :to="'/'+getMerchant().code+'/dev/hotel/check-in'">
          <div class="py-3 px-4 mt-3 cursor-pointer" style="background-color: #ff614417">
            <div class="row slim-grid-row">
              <div class="col-1">
                <i class="iconsmind-Key body-2-2 text-24 position-relative align-center" style="top: 2px"></i>
              </div>
              <div class="col-10">
                <p class="mb-0 ml-3 body-2-2 text-12 font-regular">{{$t('hotel.you-have-reservation')}}</p>
                <p class="mb-0 ml-3 body-2-2 font-semibold">{{$t('hotel.check-in-now')}}</p>
              </div>
              <div class="col-1 text-right">
                <i class="simple-icon-arrow-right body-2-2 position-relative align-center"></i>
              </div>
            </div>
          </div>
        </router-link>
      </div> -->
      <!-- <div class="">
        <router-link :to="'/'+getMerchant().code+'/dev/hotel/home'">
          <div class="py-3 px-4 mt-3 cursor-pointer" style="background-color: #79a33a7a">
            <div class="row slim-grid-row">
              <div class="col-1">
                <i class="simple-icon-home body-2-2 text-24 position-relative align-center" style="top: 2px"></i>
              </div>
              <div class="col-10">
                <p class="mb-0 ml-3 body-2-2 text-12 font-regular">You have checked in</p>
                <p class="mb-0 ml-3 body-2-2 font-semibold">Back to Hotel Fitur</p>
              </div>
              <div class="col-1 text-right">
                <i class="simple-icon-arrow-right body-2-2 position-relative align-center"></i>
              </div>
            </div>
          </div>
        </router-link>
      </div> -->
      <div class="mb-3 container bg-light-page" style="padding: 12px 0 10px;border-top: 1px solid #eee;border-bottom: 1px solid #eee;">
        <div class="row no-gutters text-center">
          <div class="col-3">
            <a :href="'tel:'+getMerchant().phone">
              <div class="text-center d-inline-block align-bottom">
                <img src="../../assets/img/icon/phone-black.png" width="22">
                <p class="body-2-2 font-semibold text-12 pt-1 mb-0">{{$t('restaurant.menu.call')}}</p>
              </div>
            </a>
          </div>
          <div class="col-3">
            <router-link :to="'/'+getMerchant().code+'/feedback'">
              <div class="text-center d-inline-block align-bottom">
                <img src="../../assets/img/icon/review.png" width="22">
                <p class="body-2-2 font-semibold text-12 pt-1 mb-0">{{$t('restaurant.menu.review')}}</p>
              </div>
            </router-link>
          </div>
          <div class="col-3">
            <router-link :to="'/'+getMerchant().code+'/gallery'">
              <div class="text-center d-inline-block align-bottom">
                <img src="../../assets/img/icon/ar-camera.png" width="22">
                <p class="body-2-2 font-semibold text-12 pt-1 mb-0">{{$t('restaurant.menu.gallery')}}</p>
              </div>
            </router-link>
          </div>
          <div class="col-3">
            <div class="text-center d-inline-block align-bottom cursor-pointer" @click="shareClick()">
              <img src="../../assets/img/icon/share.png" width="22">
              <p class="body-2-2 font-semibold text-12 pt-1 mb-0">{{$t('restaurant.menu.share')}}</p>
              <div v-if="action_success.show" class="px-3 mt-1 py-2 border radius-0 text-center d-table position-absolute w-auto" style="background-color: rgb(243, 255, 249); border-color: rgb(184, 254, 205) !important;right: 12px;top: 45px;">
                <p class="mb-0 body-3-1">{{action_success.message}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container px-4">
        <div class="my-3 pt-3">
          <template v-if="getMerchant().description != ''">
            <p class="mb-2 body-3-3 text-16 font-bold">{{$t('general.description')}}</p>
            <div class="mb-0 body-3-3 text-14 font-regular text-truncate-10 html-desc" :class="{'text-truncate-normal':is_open}" v-html="getMerchant().description">
            </div>
            <div class="mb-3 pb-2">
              <span class="font-semibold body-2-2 text-14 underline cursor-pointer" v-if="!is_open" @click="isOpen()">{{$t("hotel.show-more")}}</span>
              <span class="font-semibold body-2-2 text-14 underline cursor-pointer" v-else @click="isOpen()">{{$t("hotel.show-less")}}</span>
            </div>
          </template>
          <template v-if="getMerchant().check_in_time_start != '' && getMerchant().check_out_time_start != ''">
            <p class="pt-3 mb-2 body-3-3 text-16 font-bold">{{$t('general.about-accommodation')}}</p>
            <div class="rounded-4 p-3 bg-light-page">
              <div class="row">
                <div class="col-6">
                  <p class="mb-0 body-2 font-regular text-12">{{$t('hotel.check-in-time')}}</p>
                  <p class="mb-0 body-2-2 font-bold text-14">{{formatTime(getMerchant().check_in_time_start)}} - {{formatTime(getMerchant().check_in_time_end)}}</p>
                </div>
                <div class="col-6">
                  <p class="mb-0 body-2 font-regular text-12">{{$t('hotel.check-out-time')}}</p>
                  <p class="mb-0 body-2-2 font-bold text-14">{{formatTime(getMerchant().check_out_time_start)}} - {{formatTime(getMerchant().check_out_time_end)}}</p>
                </div>
              </div>
            </div>
          </template>
          <template v-if="getMerchant().facilities.length > 0">
            <p class="pt-4 mt-1 mb-2 body-3-3 text-16 font-bold">{{$t('general.facilities')}}</p>
            <template>
              <div class="position-relative">
                <div class="mobile-none width-60 text-center d-inline-block position-absolute bg-smoth-light cursor-pointer" style="width: 20px;left: 0;z-index: 9" @click="xScroll('left', 'room-facilities')" v-if="getMerchant().facilities.length > 4">
                  <img src="../../assets/img/icon/down-arrow.png" width="18" class="next-button" style="transform: rotate(90deg);margin-top: 12px;" />
                </div>
                <div class="div-wrapper mx-auto d-inline-block m-width-100" id="room-facilities" style="width: 98%;">
                  <div class="text-center" style="width: max-content">
                    <div class="text-center d-inline-block" >
                      <div class="width-80px height-100px ml-1 d-inline-block align-bottom overflow-hidden" v-for="data in getMerchant().facilities">
                        <div class="rounded-10 p-5px mt-1 w-45px mx-auto d-inline-block bg-transparent-green">
                          <i class="text-green size-icon position-relative top-4px object-fit p-1" :class="data.icon"></i>
                        </div>
                        <p class="mb-0 body-3-3 text-14 mt-1 text-center">{{data.name}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mobile-none width-60 text-center d-inline-block bg-smoth-light position-absolute cursor-pointer" style="width: 20px;right: 5px;top: 0;z-index: 9" @click="xScroll('right', 'room-facilities')" v-if="getMerchant().facilities.length > 4">
                  <img src="../../assets/img/icon/down-arrow.png" width="18" class="next-button" style="transform: rotate(-90deg);margin-top: 12px;" />
                </div>
              </div>
            </template>
          </template>
          <p class="pt-4 mt-1 mb-2 body-3-3 text-16 font-bold">{{$t('general.location')}}</p>
          <p class="mb-2 pb-2 body-3-3 text-14 font-semibold"><img src="../../assets/img/hotel/marker.png" class="mr-2" width="15"> {{getMerchant().address}}</p>
          <div class="w-100 pb-4">
            <iframe v-if="hasLocationEmbedMap" :src="getMerchant().location_embed_map" class="w-100 rounded-3" height="250" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            <gmap-map v-else-if="map.center.lat != null":center="map.center" :zoom="15" style="width:100%;  height: 250px;">
                <gmap-marker :key="index" v-for="(m, index) in map.markers" :position="m.position"></gmap-marker>
            </gmap-map>
          </div>
          <!-- NEARBY -->
          <!-- <div class="pb-1 pt-2">
            <div class="">
              <div class="row">
                <div class="col-8">
                  <p class="mb-0 body-3-3 text-16 font-bold">{{$t('hotel.nearby')}}</p>
                </div>
                <div class="col-4 text-right">
                  <router-link :to="'/'+getMerchant().code+'/dev/hotel/nearby'">
                    <p class="mb-0 mt-1 text-green body-3-3-1 font-semibold text-truncate">{{$t('general.view-all')}} <img src="../../assets/img/icon/right-arrow.png" width="15"></p>
                  </router-link>
                </div>
              </div>
              <p class="mb-0 body-3-3-1">{{$t('hotel.nearby-desc')}}</p>
              <div class="position-relative">
                <div class="mobile-none width-60 text-center d-inline-block position-absolute bg-smoth-light cursor-pointer" style="width: 20px;left: -17px;top: 69px" @click="xScroll('left', 'nearby')">
                  <img src="../../assets/img/icon/green-arrow-left.png" width="18" class="next-button position-relative" style="left: 0;z-index: 9">
                </div>
                <div class="div-wrapper mx-auto d-inline-block m-width-100" id="nearby" style="width: 100%">
                  <div class="pr-3" style="width: max-content">
                    <div class="w-img-nearby d-inline-block mt-3 mr-3" v-for="(data,index) in nearby" @click="openIs(data,'detail-nearby')">
                      <img :src="data.img" class="w-100 rounded-4 object-fit" width="130" height="135">
                      <p class="mb-0 body-2 font-bold text-truncate text-light-black mt-2">{{data.name}}</p>
                      <p class="mb-0 body-3-3-1 font-semibold text-truncate">{{data.desc}}</p>
                    </div>
                  </div>
                </div>
                <div class="mobile-none width-60 text-center d-inline-block bg-smoth-light position-absolute cursor-pointer" style="width: 20px;right: -20px;top: 65px;" @click="xScroll('right', 'nearby')">
                  <img src="../../assets/img/icon/green-arrow-right.png" width="18" class="next-button position-relative" style="right: 12px;z-index: 9">
                </div>
              </div>
            </div>
          </div> -->
          <div class="border-bottom py-2 mb-2 mt-1 cursor-pointer" @click="isToggle('term')" v-if="getMerchant().terms_and_conditions != ''">
            <div class="row slim-grid-row">
              <div class="col-11">
                <p class="mb-0 body-3-3 text-16 font-bold">{{$t('merchant.term-condition')}}</p>
              </div>
              <div class="col-1">
                <i class="simple-icon-arrow-right mt-2"></i>
              </div>
            </div>
          </div>
          <div class="border-bottom py-2 my-2 cursor-pointer" @click="isToggle('policy')" v-if="getMerchant().cancellation_policy != ''">
            <div class="row slim-grid-row">
              <div class="col-11">
                <p class="mb-0 body-3-3 text-16 font-bold">{{$t('merchant.cancellation-policy')}}</p>
              </div>
              <div class="col-1">
                <i class="simple-icon-arrow-right mt-2"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="height-30px"></div>
    </template>
    <transition name="fade">
      <template v-if="is_policy">
        <div class="position-relative" style="z-index: 1037;">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-block nav-bottom" style="bottom:0px;top: 0">
              <div class="custom-container-fluid px-0" style="box-shadow: 1px 0px 6px 2px #dfdfdf4f">
                <div class="row justify-content-center no-gutters">
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                    <div class="container px-4 py-3 bg-white box-shadow-main" style="height: 100vh;min-height: 100%">
                      <div class="mb-2 pb-1">
                        <img src="../../assets/img/icon/close.png" class="my-2 d-inline-block mr-2 cursor-pointer" width="15" @click="isToggle(false)">
                        <p class="mb-0 body-2-2 text-16 font-bold d-inline-block" v-if="is_policy == 'term'">{{$t('merchant.term-condition')}}</p>
                        <p class="mb-0 body-2-2 text-16 font-bold d-inline-block" v-else>{{$t('merchant.cancellation-policy')}}</p>
                      </div>
                      <div class="scroll-hide-mobile" style="height: 100vh;overflow-y: scroll;">
                        <template v-if="is_policy == 'term'">
                          <div class="mb-2 body-2-2 html-desc" v-html="getMerchant().terms_and_conditions"></div>
                        </template>
                        <template v-else>
                          <div class="mb-2 body-2-2 html-desc" v-html="getMerchant().cancellation_policy"></div>
                        </template>
                        <div class="height-50px"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition>
    <transition name="fade">
      <template>
        <div class="position-relative" style="z-index: 1027;" v-if="scrollPosition > 100">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-block" style="bottom:0px">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                    <div class="container bg-white px-4 py-12px" style="box-shadow: 0px -3px 13px 0px #0000000f">
                      <div class="row">
                        <template v-if="!getMerchant().use_booking_engine">
                          <div class="col-8">
                            <p class="mb-0 body-2-2 text-16 font-bold">{{$t('hotel.access-your-guestapp')}}</p>
                            <p class="mb-0 body-2-2 text-12">{{$t('hotel.access-your-guestapp-desc')}}</p>
                          </div>
                          <div class="col-4">
                            <router-link :to="'/'+getMerchant().code+'/concierge'">
                              <button type="button" class="button-secondary mt-2 w-100">
                                Try Now
                              </button>
                            </router-link>
                          </div>
                        </template>
                        <template v-else>
                          <div class="col-6">
                            <p class="mb-0 body-2-2 text-12">{{$t('merchant.starting-from')}}</p>
                            <p class="mb-0 body-2-2 text-16 text-orange font-semibold d-inline-block">{{formatCurrency(startingFrom())}}</p>
                          </div>
                          <div class="col-6" @click="trackFindRoomsClick()">
                            <router-link :to="'/'+getMerchant().code+'/booking'">
                              <button type="button" class="button-secondary w-100">{{$t('hotel.find-rooms')}}</button>
                            </router-link>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition>
    <!-- Detail Nearby -->
    <transition name="fade">
      <template v-if="is_popup=='detail-nearby'">
        <div class="position-relative" style="z-index: 1036">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-block nav-bottom" style="bottom:0%;top: 0">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                    <div class="bg-white">
                      <div class="w-100 popup-full">
                        <div class="">
                          <img src="../../assets/img/icon/cancel.png" class="d-inline-block p-2 rounded-10 bg-back mt-3 mx-4 cursor-pointer position-absolute" width="33" @click="openIs('close')" style="z-index: 1049">
                            <flickity ref="flickity" class="room-detail" :options="flickityOptions">
                              <div class="carousel-cell w-100" id="carousel-cell1">
                                <div class="w-100" style="height: 250px !important;">
                                  <img src="../../assets/img/hotel/ubud.jpg" class="img-fit" height="250">
                                </div>
                              </div>
                              <div class="carousel-cell w-100" id="carousel-cell2">
                                <div class="w-100" style="height: 250px !important;">
                                  <img src="../../assets/img/hotel/ubud-1.jpg" class="img-fit" height="250">
                                </div>
                              </div>
                              <div class="carousel-cell w-100" id="carousel-cell3">
                                <div class="w-100" style="height: 250px !important;">
                                  <img src="../../assets/img/hotel/building.jpg" class="img-fit" height="250">
                                </div>
                              </div>
                            </flickity>
                          <div class="container px-4 mb-3">
                            <p class="mb-1 body-1-4 text-20">Rice Terrace Relaxation Spot</p>
                            <p class="mb-0 body-3-3-1 font-semibold text-truncate"><img src="../../assets/img/hotel/marker.png" width="15" class="position-relative" style="left: -2px;top: -2px"> Tegalalang, Gianyar, Bali</p>
                            <div class="d-block">
                              <img src="../../assets/img/icon/tour.png" class="d-inline-block" width="80">
                              <p class="mb-0 body-2-2 font-regular text-12 d-inline-block">Dari 5.233 review</p>
                              <p class="mb-0 d-block body-2-2 font-semibold text-green">See review</p>
                            </div>
                            <div class="my-3">
                              <p class="mb-2 pt-2 body-3-3 text-16 font-bold">Description</p>
                              <p class="body-3-3 text-14 font-regular">The room is an enclosed place with a ceiling that is in a house or other form of building. The room usually has a door and several windows that function as a place for light entry, air flow, and access to the room</p>
                              <p class="mb-2 pt-2 body-3-3 text-16 font-bold">Facilities</p>
                                <Facilities :facilities="getMerchant().facilities"></Facilities>
                                <p class="mb-2 pt-2 mb-2 body-3-3 text-16 font-bold">Location</p>
                                <p class="mb-1 body-3-3 text-14 font-semibold"><img src="../../assets/img/hotel/marker.png" class="mr-2" width="15"> Jl. Monkey Forest, Ubud, Kecamatan Ubud, Kabupaten Gianyar, Bali 80571</p>
                                <div class="w-100">
                                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3945.92309465687!2d115.26028911451677!3d-8.506848288477336!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd23df37ee27943%3A0xce7e56a381f72d62!2sMonkey%20forest!5e0!3m2!1sid!2sid!4v1605505340731!5m2!1sid!2sid" class="w-100 rounded-3" height="250" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                                </div>
                            </div>
                          </div>
                          <div class="container px-4 my-2 pt-2 pb-1">
                            <button type="button" class="button-primary w-100">Redirect Now</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition>
    <transition name="fade">
      <template v-if="all_facilities || is_policy">
        <PopUpBackground></PopUpBackground>
      </template>
    </transition>
    <!-- <Navigation></Navigation> -->
  </div>
</template>
<script>
  import {mapGetters, mapMutations} from 'vuex';
  import Flickity from 'vue-flickity';
  import Navigation from '@/components/dev/Navigation';
  import PopUpBackground from '@/components/dev/PopUpBackground.vue';
  import Facilities from '@/components/hotel/facilities';
  import {get} from '@/services/index.js'
  import moment from 'moment'
  import {formatCurrency} from '@/utils/index.js'

  import room1 from '../../assets/img/hotel/room1.jpg';
  import room2 from '../../assets/img/hotel/room2.jpg';
  import room3 from '../../assets/img/hotel/room3.jpg';
  import nearby1 from '../../assets/img/hotel/ubud.jpg';
  import nearby2 from '../../assets/img/hotel/building.jpg';
  import nearby3 from '../../assets/img/hotel/austria.jpg';
  import nearby4 from '../../assets/img/hotel/paris.jpg';
  import nearby5 from '../../assets/img/hotel/ubud-1.jpg';

  export default{
    components: {
      Flickity,
      Navigation,
      Facilities,
      PopUpBackground
    },
    data() {
      return {
        is_open: false,
        is_tab: 'Hotel',
        is_popup: '',
        rooms_filter: '',
        starting_from: '',
        is_policy: false,
        all_facilities: false,
        is_category: 1,
        scrollPosition: null,
        merchant_area: '',
        room_category: [
          {
            id: 1,
            name: 'Hotel',
            type: true,
          },
          {
            id: 3,
            name: 'Facilities',
            type: false,
          },
          {
            id: 4,
            name: 'Garden',
            type: false,
          },
          {
            id: 5,
            name: 'Dining Room',
            type: false,
          }
        ],
        nearby:[
          {
            id: 1,
            name: 'Ubud',
            desc: 'Ubud, Bali',
            title:'Rice Terrace Relaxation Spot',
            location: 'Tegalalang, Gianyar, Bali',
            img: nearby1
          },
          {
            id: 2,
            name: 'Belega',
            desc: 'Gianyar, Bali',
            title:'Historical Statue Monument',
            location: 'Monumen di Richmond, Virginia',
            img: nearby2
          },
          {
            id: 3,
            name: 'Green Place',
            desc: 'Wina, Austria',
            title:'Beautiful Mountains of Greenland',
            location: 'Monumen di Richmond, Virginia',
            img: nearby3
          },
          {
            id: 4,
            name: 'Paris',
            desc: 'Paris, Prancis',
            title:'Menara Eiffel of Paris',
            location: 'Paris, Prancis',
            img: nearby4,
          },
          {
            id: 5,
            name: 'Kuta',
            desc: 'Kuta, Bali',
            title:'Ubud Puri with Cultural Heritage',
            location: 'Ubud Village, Gianyar, Bali',
            img: nearby5
          },
        ],
        flickityOptions: {
          initialIndex: 0,
          autoPlay: 3000,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: true,
        },
        map:{
          center: { lat: null, lng: null },
          markers: []
        },
        action_success: {
          show: '',
          message: '',
          timer: ''
        }
      }
    },
    computed:{
      show_success(){
        return this.action_success.show
      },
      hasLocationEmbedMap(){
        return this.$isNotEmptyV2(this.getMerchant().location_embed_map)
      }
    },
    watch:{
      show_success(){
        if (this.action_success.show) {
          let looping = setInterval(() => {
            if (this.action_success.timer > 0) {
              this.action_success.timer--
            }else if(this.action_success.timer == 0){
              this.action_success.show = false
              this.action_success.message = ''
              clearInterval(looping)
            }
          },1000) 
        }
      }
    },
    mounted() {
      this.loadSearchByRoomType()
      window.addEventListener('scroll', this.updateScroll);
      document.getElementById('hotel-room').scrollIntoView({
        behavior: 'smooth'
      });
      this.loadMerchantArea()
      this.map.center = {
        lat : this.getMerchant().lat,
        lng : this.getMerchant().lng
      }
      this.map.markers = []
      this.map.markers.push({ position: this.map.center });
    },
    methods: {
      ...mapGetters(['getMerchant', 'getBePrice','getCurrentLanguage']),
      ...mapMutations(['resetBeFilter']), 
      isOpen(){
        this.is_open = !this.is_open
      },
      xScroll(type, id) {
        let content = document.querySelector("#" + id);
        if (type == 'left') {
          content.scrollLeft -= 80;
        } else {
          content.scrollLeft += 80;
        }
      },
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      navTab(data){
        this.is_tab = data
        document.getElementById('hotel-room').scrollIntoView({
          behavior: 'smooth'
        });
      },
      openIs(data, tab){
        this.detail_facilities = data
        this.is_popup = tab
      },
      toggleFacilities(){
        this.all_facilities = !this.all_facilities
      },
      loadMerchantArea(){
        get("CORE","user-location",{
          lat: this.getMerchant().lat,
          long: this.getMerchant().lng
        }).then(response=>{
          let location_type = response.data.data.address_components
            for(let i = 0; i < location_type.length;i++){
                if (location_type[i].types[0] == 'administrative_area_level_3') {
                    this.merchant_area = location_type[i].short_name;
                    break;
                }
            }
        })
      },
      shareClick(){
        var value = window.location.href;
        var input_temp = document.createElement("input");
        input_temp.value = value;
        document.body.appendChild(input_temp);
        input_temp.select();
        document.execCommand("copy");
        document.body.removeChild(input_temp);
        this.action_success.show = true
        this.action_success.message = 'Link Copied'
        this.action_success.timer = 1
      },
      isToggle(data){
        this.is_policy = data
      },
      formatTime(time){
        return moment(time, 'HH:mm:ss').format('HH:mm')
      },
      trackFindRoomsClick(){
        this.$trackHomeClick('', 'Clicked Find Rooms')
        this.resetBeFilter()
      },
      loadSearchByRoomType() {
        let check_in = new Date()
        let check_out = moment(new Date()).add(1,'d').toDate()
        let params = {
          merchant_id: this.getMerchant().id,
          check_in_date: moment(check_in).format("YYYY-MM-DD"),
          check_out_date: moment(check_out).format("YYYY-MM-DD"),
          adult: 1,
          child: 0,
          infant: 0,
          sort_by: 'room_type',
          min_price: this.getBePrice()[0],
          max_price: this.getBePrice()[1],
          filter_by: 'price',
          language_code: this.getCurrentLanguage(),
          use_promotion_combine:true
        }
        get("CORE_HOTEL", "search-room",
          params
        ).then(response => {
          let res = response.data
          if (res.success) {
            this.rooms_filter = res.data
            this.startingFrom()
          }else{
            this.message = this.$t("hotel.error."+res.message)
          }
        })
      },
      startingFrom(){
        let lowest = 0
        for(let i=0;i<this.rooms_filter.length;i++){
          let final_price = this.rooms_filter[i].best_price.final_price
          if(i==0){
            lowest = final_price
          }
          if(lowest>final_price){
            lowest = final_price
          }
        }
        return lowest
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      xScroll(type, id) {
        let content = document.querySelector("#" + id);
          if (type == 'left') {
            content.scrollLeft -= 80;
          }else {
            content.scrollLeft += 80;
          }
      },
      toggleFacilities(){
        this.all_facilities = !this.all_facilities
      }
    },
  }
</script>
<style scoped>
@media screen and (max-width: 655px) {
  .mobile-none{
    display: none !important;
  }
} 
.delay{
  animation-delay: 0.3s;
  transition: 0.1s;
}
</style>


// WEBPACK FOOTER //
// src/pages/hotel/HotelDetail.vue